/**
 * Implementación del repositorio de User usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { UserRepository } from '@domain/repositories/user.repository';
import { User } from '@domain/models/user.model';
import { UserDto } from '@infra/dto/user.dto';
import { UserMapper } from '@infra/mappers/user.mapper';

@Injectable({ providedIn: 'root' })
export class UserRepositoryImpl implements UserRepository {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/v1/professionals`;

  getNewUsers(): Observable<User[]> {
    return this.http.get<UserDto[]>(this.apiUrl).pipe(
      map(dtos => UserMapper.toDomainList(dtos))
    );
  }
}

